/** Shared indexed palette for all authored artwork. Index 0 is always transparent. */
export const ART_PALETTE = [
  '#00000000',
  '#23202eff', '#3d3547ff', '#5c4038ff', '#8a4a3fff', '#b8624aff', '#e08a63ff',
  '#a9713fff', '#d59a5cff', '#edc07eff', '#f7d9a0ff', '#fdf0d0ff',
  '#1e4436ff', '#33684aff', '#4f8c50ff', '#77b25cff', '#a8d073ff', '#cfdd77ff',
  '#24596eff', '#3d8ba0ff', '#5fb3b8ff', '#97d9cdff', '#dcf5ecff', '#fbfdf5ff',
  '#454a5cff', '#6b7288ff', '#9aa2b3ff', '#c9d0daff',
  '#e0503fff', '#5b7099ff', '#c8477eff', '#000000ff',
];

export const ART_PALETTE_NAMES = [
  'Transparent',
  'Ink', 'Deep shadow', 'Brown shadow', 'Cliff dark', 'Cliff', 'Cliff light',
  'Earth dark', 'Earth', 'Sand', 'Sand light', 'Cream',
  'Forest', 'Dark grass', 'Grass', 'Bright grass', 'Grass light', 'Yellow green',
  'Water shadow', 'Water dark', 'Water', 'Water light', 'Foam', 'Highlight',
  'Stone shadow', 'Stone dark', 'Stone', 'Stone light',
  'Signal red', 'Slate blue', 'Berry', 'True black',
];
